<template>
  <div class="modal">
    <transition name="fade">
      <div class="modal-wrapper">
        <div class="content">
          <slot name="content" />
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.modal {
  position: absolute;

  display: flex;
  justify-content: center;
  align-items: center;

  height: 100vh;
  height: 100dvh;
  inset: 0;

  overflow-y: auto;

  @media screen and (max-width: $small-screen) {
    margin: 24px 0;
    height: auto;
  }

  .modal-wrapper {
    position: relative;
    max-width: 1350px;
    width: 95%;
    min-height: 512px;
    height: fit-content;
    background-color: #1D1D1D;
    pointer-events: auto;
    
    padding: 24px 56px 50px 64px;

    display: flex;
    flex-direction: column;

    @media screen and (max-width: $small-screen) {
      min-height: 0;
      height: 100%;
      overflow-y: scroll;
      padding: 10px 24px 10px 24px;
    }

    .progress-header {
      height: 4px;
      margin: 0 -32px;
      margin-bottom: 40px;

      display: flex;
      align-items: center;
      gap: 8px;

      .progress {
        height: 4px;

        flex: 1;

        border-radius: 6px;
        background: #464646;

        &.active {
          background: #F2CB36;
        }
      }
    }

    .content {
      flex: 1;
      display: flex;
      justify-content: center;

      @media screen and (max-width: $small-screen) {
        padding-top: 32px;
      }
    }
  }
}
</style>

<script setup lang="ts">
defineProps({
  progress: {
    type: Number,
    required: true,
  },
  progressTotal: {
    type: Number,
    required: true,
  },
});

</script>